import React from 'react';
import styled from 'styled-components';
import {
  Card,
  Grid,
  MenuItem,
  FormControl,
  Select,
  Typography
} from '@material-ui/core';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';

const StyledTitle = styled(Typography)`
  text-transform: uppercase;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 12px;
`;

const StyledForm = styled('div')`
  margin-top: 10px;
  .formControl {
    min-width: 100%;
    background-color: #ededed;
  }
`;
export interface JiraPriorityCardProps {
  issue: any;
}

const JiraPriorityCard: React.FC<JiraPriorityCardProps> = ({ issue }) => {
  const { fields } = issue;
  const overallPriority = fields.customfield_10035?.value || 'None';
  const patientExperience = fields.customfield_10037?.value || 'None';
  const patientSafety = fields.customfield_10036?.value || 'None';
  const qualityImprovement = fields.customfield_10038?.value || 'None';
  const providerExperience = fields.customfield_10039?.value || 'None';
  const costReduction = fields.customfield_10041?.value || 'None';
  const revenueGenerator = fields.customfield_10040?.value || 'None';

  const PrioritySelect: React.FC<{ title: string; value: any }> = ({
    title,
    value
  }) => {
    return (
      <StyledForm>
        <StyledTitle>{title}</StyledTitle>
        <FormControl className='formControl'>
          <Select value={value} style={{ paddingLeft: 10 }}>
            <MenuItem value='None'>None</MenuItem>
            <MenuItem value='Low'>Low</MenuItem>
            <MenuItem value='Medium'>Medium</MenuItem>
            <MenuItem value='High'>High</MenuItem>
            <MenuItem value='Very High'>Very High</MenuItem>
          </Select>
        </FormControl>
      </StyledForm>
    );
  };

  const BooleanSelect: React.FC<{ title: string; value: any }> = ({
    title,
    value
  }) => {
    return (
      <StyledForm>
        <StyledTitle>{title}</StyledTitle>
        <FormControl className='formControl'>
          <Select value={value} style={{ paddingLeft: 10 }}>
            <MenuItem value='None'>None</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='Yes'>Yes</MenuItem>
          </Select>
        </FormControl>
      </StyledForm>
    );
  };

  return (
    <Card>
      <CardTitle>
        <AssignmentLateIcon />
        Priority
      </CardTitle>
      <CardContent padding='medium'>
        <Grid container spacing={1}>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={4}>
              <PrioritySelect
                title={'Overall Priority'}
                value={overallPriority}
              />
            </Grid>
            <Grid item xs={4}>
              <BooleanSelect
                title={'PT. Experience'}
                value={patientExperience}
              />
            </Grid>
            <Grid item xs={4}>
              <BooleanSelect title={'Patient Safety'} value={patientSafety} />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={4}>
              <BooleanSelect
                title={'Quality Improvement'}
                value={qualityImprovement}
              />
            </Grid>
            <Grid item xs={4}>
              <BooleanSelect
                title={'Provider Experience'}
                value={providerExperience}
              />
            </Grid>
            <Grid item xs={4}>
              <BooleanSelect title={'Cost Reduction'} value={costReduction} />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={4}>
              <BooleanSelect
                title={'Revenue Generator'}
                value={revenueGenerator}
              />
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JiraPriorityCard;
